import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const GoldMedal: FunctionalComponent<IIconProps> = ({ width = '10', height = '10', fill = '#8A6702' }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} fill="none" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.25 0a1 1 0 0 1 1 1v.5H9a1 1 0 0 1 1 1V3a3.502 3.502 0 0 1-2.53 3.364A3.248 3.248 0 0 1 5.5 7.462V9H6c.527 0 1 .5.997 1H7 3c0-.5.448-1 1-1h.5V7.462a3.245 3.245 0 0 1-1.969-1.098A3.5 3.5 0 0 1 0 3v-.5a1 1 0 0 1 1-1h.75V1a1 1 0 0 1 1-1h4.5zm-5.5 2.5H1V3c0 .725.309 1.379.803 1.835a3.274 3.274 0 0 1-.053-.585V2.5zM9 2.5h-.75v1.75c0 .2-.018.395-.053.585a2.492 2.492 0 0 0 .8-1.727L9 3v-.5z"
        fill={fill}
      />
    </svg>
  );
};

export default GoldMedal;
